import FigFree from '../../resources/icons/FigFree.png'
import FigLet from '../../resources/icons/FigLet.png'
import FigLite from '../../resources/icons/FigLite.png'
import FigFlow from '../../resources/icons/FigFlow.png'
import FigPeak from '../../resources/icons/FigPeak.png'

export const Figpasses = [
  {
    id: 1,
    image: FigFree,
    name: "FIGFREE",
    price: 0,
    description:
      "UNLOCK FIGFREE NEAR YOU! access to DISCOVERY rewards UNLIMITED figs ( locations ) NO commitment to gameplay",
    gems: 500,
    grainPerFig: 25,
    grainsLevelUp: 500,
  },
  {
    id: 2,
    image: FigLet,
    name: "FIGLET",
    price: 8.99,
    description:
      "Offering a modest step up, figlet aims to provide you with easy to find locations and experience the of winning ",
    gems: 1000,
    grainPerFig: 50,
    grainsLevelUp: 500,
  },
  {
    id: 3,
    image: FigLite,
    name: "FIGLITE",
    price: 22.99,
    description:
      "a mid option, balances higher reward potential for our committed users to discover limited locations",
    gems: 2800,
    grainPerFig: 100,
    grainsLevelUp: 500,
  },
  {
    id: 4,
    image: FigFlow,
    name: "FIGFLOW",
    price: 36.99,
    description:
      "Designed for our serious hunters seeking significant jump in potential winnings reflects.",
    gems: 2800,
    grainPerFig: 100,
    grainsLevelUp: 500,
  },
  {
    id: 5,
    image: FigPeak,
    name: "FIGPEAK",
    price: 89.99,
    description:
      "the ultimate rewards targeting the most dedicated and competitive players chasing top ranks on the leaderboard",
    gems: 2800,
    grainPerFig: 100,
    grainsLevelUp: 500,
  },
];

export const FigpassGem = {
  details: `universal in-app currency. Users can use Gems to unlock locations "Figs", access special features, or participate in exclusive events within the app. Gems can be earned through gameplay or purchased directly within the app.

            Gems can be converted into real-world rewards or money`,
};